import React, { useEffect, useState } from "react";
import { Button, Col, Form, Offcanvas, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { commonService } from "../../../../utils/commonService";
import { MultiSelect } from "primereact/multiselect";
import { useRef } from "react";

const FilterModal = ({
    showModal,
    closeModal,
    propertyCode,
    leftFilterProp,
    rightFilterProp,
    updateFilter,
}) => {
    let statusValue = {
        C: "Cancelled",
        I: "Checked In",
        N: "No Show",
        O: "Checked Out",
        R: "Reserved",
    };

    const [leftFilter, setLeftFilter] = useState(leftFilterProp);
    const [rightFilter, setRightFilter] = useState(rightFilterProp);
    const [leftStartDate, setLeftStartDate] = useState();
    const [leftEndDate, setLeftEndDate] = useState();
    const [rightStartDate, setRightStartDate] = useState();
    const [rightEndDate, setRightEndDate] = useState();
    const [leftBookingStart, setLeftBookingStart] = useState();
    const [leftBookingEnd, setLeftBookingEnd] = useState();
    const [rightBookingStart, setRightBookingStart] = useState();
    const [rightBookingEnd, setRightBookingEnd] = useState();
    const handleDateChange = (event, filterSide) => {
        const [start, end] = event;
        let startSelectedDate = "",
            endSelectedDate = "";
        if (start) {
            let date = new Date(start);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            //   startRangeDateRef.current = startSelectedDate;
        }
        if (end) {
            let date = new Date(end);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            //   endRangeDateRef.current = endSelectedDate;
        }

        if (filterSide === "left") {
            setLeftStartDate(event[0]);
            setLeftEndDate(event[1]);
        } else if (filterSide === "right") {
            setRightStartDate(event[0]);
            setRightEndDate(event[1]);
        } else if (filterSide === "bookingLeft") {
            setLeftBookingStart(event[0]);
            setLeftBookingEnd(event[1]);
        } else if (filterSide === "bookingRight") {
            setRightBookingStart(event[0]);
            setRightBookingEnd(event[1]);
        }
        if (event[0] !== null && event[1] !== null) {
            //Call Api Here
        }
    };

    useEffect(() => {
        setLeftFilter(leftFilterProp);
        setRightFilter(rightFilterProp);
        setLeftStartDate(leftFilterProp?.stayDateStart);
        setLeftEndDate(leftFilterProp?.stayDateEnd);
        setLeftBookingStart(leftFilterProp?.bookStartDate);
        setLeftBookingEnd(leftFilterProp?.bookEndDate);

        setRightStartDate(rightFilterProp?.stayDateStart);
        setRightEndDate(rightFilterProp?.stayDateEnd);
        setRightBookingStart(rightFilterProp?.bookStartDate);
        setRightBookingEnd(rightFilterProp?.bookEndDate);
    }, []);

    return (
        <Offcanvas
            className="notification-canvas filter-canvas"
            show={showModal}
            onHide={closeModal}
            placement="end"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <Button id={commonService.generateGlobalClickTrackerID("FilterModal", "apply")}
                        className="default-btn primary-btn"
                        onClick={() => {
                            if (leftStartDate && leftEndDate) {
                                leftFilter.stayDateStart =
                                    commonService.getDateForNode(leftStartDate);
                                leftFilter.stayDateEnd =
                                    commonService.getDateForNode(leftEndDate);
                            }

                            if (leftBookingStart && leftBookingEnd) {
                                leftFilter.bookStartDate =
                                    commonService.getDateForNode(leftBookingStart);
                                leftFilter.bookEndDate =
                                    commonService.getDateForNode(leftBookingEnd);
                            }

                            if (rightStartDate && rightEndDate) {
                                rightFilter.stayDateStart =
                                    commonService.getDateForNode(rightStartDate);
                                rightFilter.stayDateEnd =
                                    commonService.getDateForNode(rightEndDate);
                            }

                            if (rightBookingStart && rightBookingEnd) {
                                rightFilter.bookStartDate =
                                    commonService.getDateForNode(rightBookingStart);
                                rightFilter.bookEndDate =
                                    commonService.getDateForNode(rightBookingEnd);
                            }
                            updateFilter(leftFilter, rightFilter);
                            closeModal();
                        }}
                    >
                        Apply
                    </Button>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body id="canvas">
                <Row>
                    <Col xl={6}>
                        <div>
                            <p>Left Filter</p>

                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">
                                    Reservation OTB as of
                                </Form.Label>
                                <DatePicker
                                    portalId="datepicker-root"
                                    id="asOfDateLeft"
                                    selected={
                                        leftFilter?.asOfDate
                                            ? commonService.convertDateInTimezone(
                                                leftFilter?.asOfDate
                                            )
                                            : ""
                                    }
                                    onChange={(date) => {
                                        setLeftFilter({
                                            ...leftFilter,
                                            asOfDate: commonService.getDateInDBFormat(date),
                                        });
                                    }}
                                />
                            </div>

                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">Stay Date</Form.Label>
                                <DatePicker id={commonService.generateGlobalClickTrackerID("FilterModal", "stay-date", propertyCode)}
                                    portalId="datepicker-root"
                                    onChange={(event) => handleDateChange(event, "left")}
                                    startDate={
                                        leftStartDate
                                            ? commonService.convertDateInTimezone(leftStartDate)
                                            : ""
                                    }
                                    endDate={
                                        leftEndDate
                                            ? commonService.convertDateInTimezone(leftEndDate)
                                            : ""
                                    }
                                    selectsRange
                                    monthsShown={2}
                                />
                            </div>

                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">Booking Date</Form.Label>
                                <DatePicker id={commonService.generateGlobalClickTrackerID("FilterModal", "booking-date", propertyCode)}
                                    portalId="datepicker-root"
                                    onChange={(event) => handleDateChange(event, "bookingLeft")}
                                    startDate={leftBookingStart ? new Date(leftBookingStart) : ""}
                                    endDate={leftBookingEnd ? new Date(leftBookingEnd) : ""}
                                    selectsRange
                                    monthsShown={2}
                                />
                            </div>

                            <div>
                                <p>Market Segment</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Market-Segment-multiselect-onchange", propertyCode)}

                                    value={Object.keys(leftFilter?.marketSegment).filter(
                                        (key) => leftFilter.marketSegment[key]
                                    )}
                                    options={Object.keys(leftFilter.marketSegment).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedMarketSegment = Object.keys(
                                            leftFilter.marketSegment
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setLeftFilter({
                                            ...leftFilter,
                                            marketSegment: updatedMarketSegment,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />

                            </div>

                            <div>
                                <p>Room Type</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Room-Type-multiselect-onchange", propertyCode)}

                                    value={Object.keys(leftFilter?.roomType).filter(
                                        (key) => leftFilter.roomType[key]
                                    )}
                                    options={Object.keys(leftFilter.roomType).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedroomType = Object.keys(
                                            leftFilter.roomType
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setLeftFilter({
                                            ...leftFilter,
                                            roomType: updatedroomType,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />
                            </div>

                            <div>
                                <p>Reservation Status</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Reservation-Status-multiselect-onchange", propertyCode)}

                                    value={Object.keys(leftFilter?.status).filter(
                                        (key) => leftFilter.status[key]
                                    )}
                                    options={Object.keys(leftFilter.status).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedstatus = Object.keys(
                                            leftFilter.status
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setLeftFilter({
                                            ...leftFilter,
                                            status: updatedstatus,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />

                            </div>

                            <div>
                                <p>WeekDay</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "WeekDay-multiselect-onchange", propertyCode)}

                                    value={Object.keys(leftFilter?.weekDays).filter(
                                        (key) => leftFilter.weekDays[key]
                                    )}
                                    options={Object.keys(leftFilter.weekDays).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedweekDays = Object.keys(
                                            leftFilter.weekDays
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setLeftFilter({
                                            ...leftFilter,
                                            weekDays: updatedweekDays,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />
                            </div>

                            <div>
                                <p>Lead Time</p>
                                <Row>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("FilterModal", "Lead-Time-form-select-onchange", propertyCode)}
                                                aria-label="Default select example"
                                                value={leftFilter?.leadTimeOperator}
                                                onChange={(e) => {
                                                    setLeftFilter({
                                                        ...leftFilter,
                                                        leadTimeOperator: e.target.value,
                                                    });
                                                }}
                                            >
                                                <option value=">=">{">="}</option>
                                                <option value="<=">{"<="}</option>
                                                <option value="=">{"="}</option>
                                            </Form.Select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Control id={commonService.generateGlobalClickTrackerID("FilterModal", "Lead-Time-form-control-onchange", propertyCode)}
                                                type="text"
                                                value={leftFilter?.leadTime}
                                                onChange={(e) => {
                                                    setLeftFilter({
                                                        ...leftFilter,
                                                        leadTime: e.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div>
                                <p>LOS</p>
                                <Row>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("FilterModal", "Operator-form-select-onchange", propertyCode)}
                                                aria-label="Default select example"
                                                value={leftFilter?.losOperator}
                                                onChange={(e) => {
                                                    setLeftFilter({
                                                        ...leftFilter,
                                                        losOperator: e.target.value,
                                                    });
                                                }}
                                            >
                                                <option value=">=">{">="}</option>
                                                <option value="<=">{"<="}</option>
                                                <option value="=">{"="}</option>
                                            </Form.Select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Control id={commonService.generateGlobalClickTrackerID("FilterModal", "Operator-form-control-onchange", propertyCode)}
                                                type="text"
                                                value={leftFilter?.los}
                                                onChange={(e) => {
                                                    setLeftFilter({
                                                        ...leftFilter,
                                                        los: e.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <p>House Account</p>
                                <Row>
                                    <Col xl={12}>
                                          <div className="d-flex align-items-center gap-4 flex-wrap">
                                        <Form.Check
                                            id={commonService.generateGlobalClickTrackerID(
                                            "FilterModal",
                                            "left-is-house-account",
                                            propertyCode
                                            )}
                                            type="checkbox"
                                            label="Exclude House Account"
                                            checked={leftFilter?.leftishouseaccount || false}
                                            onChange={(e) => {
                                            setLeftFilter((prev) => ({
                                                ...prev,
                                                leftishouseaccount: e.target.checked,
                                            }));
                                            }}
                                        />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col xl={6}>
                        <div>
                            <p>Right Filter</p>

                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">
                                    Reservation OTB as of
                                </Form.Label>
                                <DatePicker
                                    portalId="datepicker-root"
                                    id="asOfDateRight"
                                    selected={
                                        rightFilter?.asOfDate
                                            ? commonService.convertDateInTimezone(
                                                rightFilter?.asOfDate
                                            )
                                            : ""
                                    }
                                    onChange={(date) => {
                                        setRightFilter({
                                            ...rightFilter,
                                            asOfDate: commonService.getDateInDBFormat(date),
                                        });
                                    }}
                                />
                            </div>
                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">Stay Date</Form.Label>
                                <DatePicker id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-stay-date", propertyCode)}
                                    portalId="datepicker-root"
                                    onChange={(event) => handleDateChange(event, "right")}
                                    startDate={
                                        rightStartDate
                                            ? commonService.convertDateInTimezone(rightStartDate)
                                            : ""
                                    }
                                    endDate={
                                        rightEndDate
                                            ? commonService.convertDateInTimezone(rightEndDate)
                                            : ""
                                    }
                                    selectsRange
                                    monthsShown={2}
                                />
                            </div>
                            <div className="startFrom from-groups no-border-break mb-3">
                                <Form.Label htmlFor="startFrom">Booking Date</Form.Label>
                                <DatePicker id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-booking-date", propertyCode)}
                                    portalId="datepicker-root"
                                    onChange={(event) => handleDateChange(event, "bookingRight")}
                                    startDate={
                                        rightBookingStart ? new Date(rightBookingStart) : ""
                                    }
                                    endDate={rightBookingEnd ? new Date(rightBookingEnd) : ""}
                                    selectsRange
                                    monthsShown={2}
                                />
                            </div>

                            <div>
                                <p>Market Segment</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-Market-Segment-multiselect-onchange", propertyCode)}

                                    value={Object.keys(rightFilter?.marketSegment).filter(
                                        (key) => rightFilter.marketSegment[key]
                                    )}
                                    options={Object.keys(rightFilter.marketSegment).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedmarketSegment = Object.keys(
                                            rightFilter.marketSegment
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setRightFilter({
                                            ...rightFilter,
                                            marketSegment: updatedmarketSegment,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />

                            </div>

                            <div>
                                <p>Room Type</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-Room-Type-multiselect-onchange", propertyCode)}

                                    value={Object.keys(rightFilter?.roomType).filter(
                                        (key) => rightFilter.roomType[key]
                                    )}
                                    options={Object.keys(rightFilter.roomType).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedroomType = Object.keys(
                                            rightFilter.roomType
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setRightFilter({
                                            ...rightFilter,
                                            roomType: updatedroomType,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />

                            </div>

                            <div>
                                <p>Reservation Status</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-Reservation-Status-multiselect-onchange", propertyCode)}

                                    value={Object.keys(rightFilter?.status).filter(
                                        (key) => rightFilter.status[key]
                                    )}
                                    options={Object.keys(rightFilter.status).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedstatus = Object.keys(
                                            rightFilter.status
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setRightFilter({
                                            ...rightFilter,
                                            status: updatedstatus,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />


                            </div>

                            <div>
                                <p>WeekDay</p>
                                <MultiSelect id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-WeekDay-multiselect-onchange", propertyCode)}

                                    value={Object.keys(rightFilter?.weekDays).filter(
                                        (key) => rightFilter.weekDays[key]
                                    )}
                                    options={Object.keys(rightFilter.weekDays).map((key) => ({
                                        label: key,
                                        value: key,
                                    }))}
                                    onChange={(e) => {
                                        const selectedValues = e.value;
                                        const updatedweekDays = Object.keys(
                                            rightFilter.weekDays
                                        ).reduce((acc, key) => {
                                            acc[key] = selectedValues.includes(key);
                                            return acc;
                                        }, {});
                                        setRightFilter({
                                            ...rightFilter,
                                            weekDays: updatedweekDays,
                                        });
                                    }}
                                    filter
                                    placeholder="Select Market Segment"
                                    display="values"
                                    selectedItemsLabel="{0} items selected"
                                    maxSelectedLabels={0}
                                    closeOnSelect={false}
                                    appendTo="self"
                                />
                            </div>

                            <div>
                                <p>Lead Time</p>
                                <Row>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-Lead-Time-operator-form-select-onchange", propertyCode)}
                                                aria-label="Default select example"
                                                value={rightFilter?.leadTimeOperator}
                                                onChange={(e) => {
                                                    setRightFilter({
                                                        ...rightFilter,
                                                        leadTimeOperator: e.target.value,
                                                    });
                                                }}
                                            >
                                                <option value=">=">{">="}</option>
                                                <option value="<=">{"<="}</option>
                                                <option value="=">{"="}</option>
                                            </Form.Select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Control id={commonService.generateGlobalClickTrackerID("FilterModal", "Right-Lead-Time-form-control-onchange", propertyCode)}
                                                type="text"
                                                value={rightFilter?.leadTime}
                                                onChange={(e) => {
                                                    setRightFilter({
                                                        ...rightFilter,
                                                        leadTime: e.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div>
                                <p>LOS</p>
                                <Row>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("FilterModal", "right-LOS-form-select-onchange", propertyCode)}
                                                aria-label="Default select example"
                                                value={rightFilter?.losOperator}
                                                onChange={(e) => {
                                                    setRightFilter({
                                                        ...rightFilter,
                                                        losOperator: e.target.value,
                                                    });
                                                }}
                                            >
                                                <option value=">=">{">="}</option>
                                                <option value="<=">{"<="}</option>
                                                <option value="=">{"="}</option>
                                            </Form.Select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="from-groups no-border-break">
                                            <Form.Control id={commonService.generateGlobalClickTrackerID("FilterModal", "right-LOS-form-control-onchange", propertyCode)}
                                                type="text"
                                                value={rightFilter?.los}
                                                onChange={(e) => {
                                                    setRightFilter({
                                                        ...rightFilter,
                                                        los: e.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                               <div>
                                <p>House Account</p>
                                <Row>
                                    <Col xl={12}>
                                       <div className="d-flex align-items-center gap-4 flex-wrap">
                                        <Form.Check
                                            id={commonService.generateGlobalClickTrackerID(
                                            "FilterModal",
                                            "right-is-House-Account",
                                            propertyCode
                                            )}
                                            type="checkbox"
                                            label="Exclude House Account"
                                            checked={rightFilter?.rightishouseaccount || false}
                                            onChange={(e) => {
                                            setRightFilter((prev) => ({
                                                ...prev,
                                                rightishouseaccount: e.target.checked,
                                            }));
                                            }}
                                        />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FilterModal;
